import { render } from "./VueDrawingCanvasWrapper.vue?vue&type=template&id=7524861a"
import script from "./VueDrawingCanvasWrapper.vue?vue&type=script&lang=js"
export * from "./VueDrawingCanvasWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__